module.exports = __webpack_public_path__ + "static/img/CACE.ffde93af.png";